import {parseForm} from "@jalik/form-parser";
import '../utils';

const order = document.getElementById("order");
const orderBtn = document.getElementById('order-toggle');

orderBtn?.addEventListener('click', () => {
    const itemName = orderBtn.dataset.itemName;
    let name = document.getElementById('item-name');

    if (name === null) {
        name = itemName;
    } else {
        name = name.textContent;
    }

    document.getElementById('subject').value = name;
    window.setTimeout(function () {
        document.getElementById('name').focus();
    }, 0);
});

order?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const body = parseForm(order);

    await requestWithCsrf(order.getAttribute('action'), body)
        .then(async response => {
            const data = await response.json();

            if (response.status !== 200) {
                messages(data);
                return;
            }
            messages(data);

            setTimeout(() => {
                location.reload();
            }, 2000);
        });
});
